import { ColumnInfo, ColumnInfoList, DisplaySetting } from 'components/shared/display_setting'
import { SelectItem } from 'components/shared/input'
import { TableCell } from 'components/shared/widget'
import { INSPECTION_STATUS_SELECT_ITEMS, RESULT_STATUS_SELECT_ITEMS, Sample, SAMPLE_STATUS_SELECT_ITEMS } from 'entities/sample'
import { ReactNode, useMemo } from 'react'
import { Badge } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { Form } from 'utils/hooks'
import { SampleViewModel } from 'view_models/sample_view_model'

export const sampleColumnInfoList = (form?: Form<Record<string, unknown>>, productSelectItems?: SelectItem[]): ColumnInfoList => {
    return {
        tableName: 'SAMPLE',
        values: [
            {
                name: 'キットタイプ',
                th: true,
                minWidth: 100,
                align: 'center',
                form: form,
                orderAttr: 'request_form__is_freezing_kit',
                searchType: {
                    name: 'isFreezingKit',
                    type: 'multiple_select',
                    selectItems: [
                        {
                            label: '冷蔵',
                            value: 'True',
                        },
                    ],
                },
            },
            {
                name: '最優先',
                th: true,
                minWidth: 80,
                align: 'center',
                form: form,
                orderAttr: 'sample_priority',
                searchType: { name: 'priority', type: 'number' },
            },
            {
                name: '再採尿',
                th: true,
                minWidth: 80,
                align: 'center',
                form: form,
                orderAttr: 'sample_is_recollect',
                searchType: { name: 'is_recollect', type: 'boolean' },
            },
            {
                name: '発送期限',
                th: true,
                minWidth: 80,
                align: 'center',
                form: form,
                orderAttr: 'sample_deadline_date',
                searchType: { name: 'deadlineDate', type: 'date' },
            },
            {
                name: '検体コード',
                th: true,
                minWidth: 120,
                align: 'center',
                form: form,
                orderAttr: 'sample_code',
                searchType: { name: 'sampleCode', type: 'multiple_text' },
            },
            {
                name: '患者コード',
                th: true,
                minWidth: 100,
                align: 'center',
                form: form,
                orderAttr: 'patient_code',
                searchType: { name: 'patientCode', type: 'text' },
            },
            {
                name: '依頼書コード',
                th: true,
                minWidth: 100,
                form: form,
                orderAttr: 'request_form__code',
                searchType: { name: 'requestForm', type: 'multiple_text' },
                align: 'center',
            },
            {
                name: '病院・施設',
                th: true,
                width: 200,
                form: form,
                orderAttr: 'sample_institution_id', // ToDo 変更
                searchType: { name: 'institutionName', type: 'multiple_text' },
                align: 'center',
            },
            {
                name: '抽出数',
                th: true,
                width: 80,
                form: form,
                align: 'center',
                orderAttr: 'sample_extraction_count',
                searchType: { name: 'extractionCount', type: 'number' },
            },
            {
                name: '採尿時間',
                th: true,
                width: 100,
                form: form,
                align: 'center',
                orderAttr: 'sample_collection_time',
            },
            {
                name: '検査報告',
                th: true,
                width: 80,
                align: 'center',
                form: form,
                orderAttr: 'result_status',
                searchType: { name: 'resultStatus', type: 'multiple_select', selectItems: RESULT_STATUS_SELECT_ITEMS },
            },
            {
                name: '状況',
                th: true,
                width: 120,
                align: 'center',
                form: form,
                orderAttr: 'sample_status',
                searchType: { name: 'sampleStatus', type: 'multiple_select', selectItems: SAMPLE_STATUS_SELECT_ITEMS },
            },
            {
                name: '検品状況',
                th: true,
                width: 120,
                align: 'center',
                form: form,
                orderAttr: 'inspection_status',
                searchType: { name: 'inspectionStatus', type: 'multiple_select', selectItems: INSPECTION_STATUS_SELECT_ITEMS },
            },
            {
                name: '製品',
                th: true,
                minWidth: 350,
                form: form,
                searchType: { name: 'productItemId', type: 'multiple_select', selectItems: productSelectItems },
            },
            {
                name: 'RUN ID',
                th: true,
                minWidth: 100,
            },
            {
                name: '保管場所',
                th: true,
                width: 100,
                align: 'center',
                form: form,
                orderAttr: 'rack__location_code',
                searchType: { name: 'rack', type: 'text' },
            },
            {
                name: '位置',
                th: true,
                width: 50,
                align: 'center',
                form: form,
                orderAttr: 'sample_tube_location',
                searchType: { name: 'tubeLocation', type: 'text' },
            },
            {
                name: '検品日',
                th: true,
                width: 100,
                align: 'center',
                form: form,
                orderAttr: 'sample_inspection_date',
                searchType: { name: 'inspectionDate', type: 'date' },
            },
            {
                name: '結果表発送日',
                th: true,
                width: 100,
                align: 'center',
                form: form,
                orderAttr: 'sample_send_date',
                searchType: { name: 'sendDate', type: 'date' },
            },
            {
                name: '研究利用',
                th: true,
                width: 100,
                align: 'center',
                form: form,
                orderAttr: 'sample_followup_study_agreement',
                searchType: {
                    name: 'followupStudyAgreement',
                    type: 'multiple_select',
                    selectItems: [
                        {
                            label: '同意',
                            value: 'true',
                        },
                        {
                            label: '拒否',
                            value: 'false',
                        },
                    ],
                },
            },
            {
                name: 'テストフラグ',
                th: true,
                minWidth: 120,
                align: 'center',
                form: form,
                searchType: {
                    name: 'isTest',
                    type: 'multiple_select',
                    selectItems: [
                        {
                            label: 'テスト用',
                            value: 'true',
                        },
                        {
                            label: '本番用',
                            value: 'false',
                        },
                    ],
                },
            },
        ],
    }
}

export type SampleTableDataProps = {
    sample?: Sample
    displaySetting: DisplaySetting
}

export const SampleTableData = ({ sample, displaySetting }: SampleTableDataProps): JSX.Element => {
    const isHomeTest = process.env.REACT_APP_IS_HOME_TEST

    if (!sample) {
        return (
            <>
                {displaySetting.columnInfoList.values.map((_: ColumnInfo, index: number) => {
                    if (displaySetting.hiddenList.includes(index)) {
                        return <></>
                    } else {
                        return <TableCell key={index}></TableCell>
                    }
                })}
            </>
        )
    }
    const vm = new SampleViewModel(sample)
    const createCells = useMemo(() => {
        return (
            <>
                <TableCell align="center">
                    {isHomeTest && !vm.object.requestForm?.isFreezingKit ? (
                        <Badge bg="secondary" style={{ width: 40 }}>
                            室温
                        </Badge>
                    ) : (
                        <Badge bg="warning" style={{ width: 40 }}>
                            冷蔵
                        </Badge>
                    )}
                </TableCell>
                <TableCell align="center">
                    {vm.object.priority === 1 ? <Badge bg="success">特急</Badge> : vm.object.priority === 2 ? <Badge bg="danger">超特急</Badge> : '-'}
                </TableCell>
                <TableCell align="center">{sample.isRecollect ? <Badge bg="success">YES</Badge> : '-'}</TableCell>
                <TableCell align="center">{vm.deadline()}</TableCell>
                <TableCell align="center">
                    <div>{sample.code}</div>
                </TableCell>
                <TableCell align="center">
                    <div>{sample.patient?.code}</div>
                </TableCell>
                <TableCell align="center">
                    <div>{sample.requestForm?.code}</div>
                </TableCell>
                <TableCell>{sample.institution?.name}</TableCell>
                <TableCell align="center">
                    {sample.extractionCount && <Link to={`extractions?sampleIdIn=${sample.id}`}>{sample.extractionCount} EXT</Link>}
                </TableCell>
                <TableCell align="center">{sample.collectionTime?.slice(0, 5)}</TableCell>
                <TableCell align="center">{vm.resultStatusView()}</TableCell>
                <TableCell align="center">{vm.statusView()}</TableCell>
                <TableCell align="center">{vm.inspectionStatusView()}</TableCell>
                <TableCell>{vm.productItemView()}</TableCell>
                <TableCell>
                    {sample.pcrRunIds?.map((id) => (
                        <a key={'sample_run-' + id} style={{ marginRight: 3 }} href={`pcr_run/${id}`} target="_blank" rel="noreferrer">
                            {id}
                        </a>
                    ))}
                </TableCell>
                <TableCell align="center">{sample.rack?.locationCode}</TableCell>
                <TableCell align="center">{sample.tubeLocation}</TableCell>
                <TableCell align="center">{vm.inspectionDateText()}</TableCell>
                <TableCell align="center">{vm.sendDateText()}</TableCell>
                <TableCell align="center">{vm.agreeStudy()}</TableCell>
                <TableCell align="center">{vm.testBadge()}</TableCell>
            </>
        )
    }, [displaySetting.hiddenList])

    return createCells.props.children.filter((_: ReactNode, index: number) => !displaySetting.hiddenList?.includes(index)).map((cell: ReactNode) => cell)
}
